import { render, staticRenderFns } from "./TomaReports.vue?vue&type=template&id=27910f5e"
import script from "./TomaReports.vue?vue&type=script&lang=js"
export * from "./TomaReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports